import { Modal } from '@coreui/coreui-pro';

window.addEventListener('closeModal', function () {
  const modal = Modal.getInstance(document.getElementById('modals-here'));
  console.log('closeModal');
  console.log(modal);
  modal.hide();
});
